export const environment = {
  environmentName: 'dev',
  kontentProjectId: 'b10776b8-0763-0096-5302-c1fb978a8bb7',
  previewKey:'ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogImJjZDA0ZWU0ZGQ3NDRmZTY5MmY0OTYxNzllYWI3ZjliIiwNCiAgImlhdCI6ICIxNjk5MDM3Njc1IiwNCiAgImV4cCI6ICIxODU2ODkwMzgwIiwNCiAgInZlciI6ICIyLjAuMCIsDQogICJzY29wZV9pZCI6ICJmNTEzNWJjNDBkNWY0NDk5ODRiNDdiMDEzNTQyZTAwOCIsDQogICJwcm9qZWN0X2NvbnRhaW5lcl9pZCI6ICI2MTY0ZTc3YWZiZDQwMDYxYTQzN2QzNTQwMGI2ZmI0YSIsDQogICJhdWQiOiAiZGVsaXZlci5rb250ZW50LmFpIg0KfQ.LhvKVn_smghv2m_LbG3BNQSLFtOpOjH_C46sZrfBkX4',
  deliveryPreview: true,  // use kontent preview API
  kontentCacheTTL: 0, // 0 = disabled, miliseconds
  apiURL: 'https://ora56g2msf.execute-api.us-east-1.amazonaws.com/prod',
};
